// extracted by mini-css-extract-plugin
module.exports = {"categories":"FaqList_categories__1Qg0F","questionsTitle":"FaqList_questionsTitle__1vPD5","header":"FaqList_header__2wauZ","title":"FaqList_title__2tpDl"};